export default "__VITE_ASSET__80ea6513__"